
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcBarHorizontal as ObcBarHorizontalElement} from '@oicl/openbridge-webcomponents/dist/building-blocks/bar-horizontal/bar-horizontal.js';
 
 
 

 
 export const ObcBarHorizontal = createComponent({
   react: React,
   tagName: 'obc-bar-horizontal',
   elementClass: ObcBarHorizontalElement,
   events: {
     
   }
  });
 
 